import { Type, Directive } from '@angular/core';
import { BaseEntity } from './base-entity.model';
import { BaseEntityService } from './base-entity.service';
import { OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Directive()
export class BaseEntityListComponent<T extends BaseEntity> implements OnInit {

  dataSource = new MatTableDataSource<T>();

  constructor(protected type: Type<T>, private entityService: BaseEntityService<T>, private __snackBar: MatSnackBar, ) { }

  @ViewChild(MatSort) sort: MatSort;

  ngOnInit() {
    this.dataSource.sort = this.sort;
    this.list();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  add(o?: object) {
    const entity = o ? new this.type(o) : new this.type();
    this.edit(entity);
  }

  list() {
    this.entityService.list().subscribe((entities: T[]) => this.dataSource.data = entities);
  }

  delete(entity: T, $event) {
    $event.stopPropagation();

    let deleteFn = () => {
      this.entityService.remove(entity).then(() => {
        this.__snackBar.open("Eliminato 😉", null, {
          duration: 1000
        });
        this.list();
      }).catch((e) => {
        console.error(e);
        this.__snackBar
          .open("Errore durante l'eliminazione 😢", "Riprova", {
            duration: 4000
          })
          .onAction()
          .subscribe(() => {
            deleteFn();
          });
      });
    }

    if (confirm("Vuoi veramente procedere con l'eliminazione?")) {
      deleteFn();
    }
    entity
  }

  save(entity: T) {
    const promise = entity.id ? this.entityService.update(entity) : this.entityService.create(entity);
    promise.then(() => {
      this.__snackBar.open("Salvato 😉", null, {
        duration: 1000
      });
      this.list();
    })
      .catch((e) => {
        console.error(e);
        this.__snackBar
          .open("Errore durante il salvataggio 😢", "Riprova", {
            duration: 4000
          })
          .onAction()
          .subscribe(() => {
            this.save(entity);
          });
      });
    return promise;
  }

  edit(entity: T) {
    console.error("Not implemented")
  }

}
